export class IPosition {
    public constructor(public x: number, public y: number) {}
}
